export const selectIncidentPlaybook = (state) =>
  state.incidentResponse.playbook;
export const selectIncidentPlaybookLoading = (state) =>
  state.incidentResponse.loadingPlaybook;
export const selectIncidentPlaybookStages = (state) =>
  state.incidentResponse.playbook?.stages || [];
export const selectResponseActionsExecuted = (state) =>
  state.incidentResponse.responseActionsExecuted;
export const selectLoadingExecutionForCoa = (state) =>
  state.incidentResponse.loadingExecutionForCoa;
